/**
 * Stap 5: de open vragen (toets, deel 2). Versturen kan pas als elke vraag
 * een antwoord heeft; daarna geeft Anna Maria per antwoord feedback (Klaar).
 */
import React from 'react';
import { Send } from 'lucide-react';
import { TekstPaneel } from '../onderdelen/TekstPaneel';
import { aantalGoed } from './MeerkeuzeUitslag';
import { stijlen } from '../stijlen';

export function OpenVragen({ titel, alineas, vragen, antwoorden, onTyp, uitslagDeel1, onVerstuur, bezig = false }) {
  const compleet = vragen.length > 0 && vragen.every(v => antwoorden[v.id]?.trim());
  return (
    <div style={stijlen.toetsRaster}>
      <TekstPaneel titel={titel} alineas={alineas}>
        {/* Na herladen is de uitslag van deel 1 er niet meer; dan staat dit vak er niet. */}
        {uitslagDeel1 && (
          <div style={{ marginTop: 24, padding: 16, background: 'var(--anna-maria)', borderRadius: 8, borderLeft: '4px solid var(--accent)' }}>
            <strong>Deel 1 resultaat:</strong> Je hebt {aantalGoed(uitslagDeel1)} van de {uitslagDeel1.length} vragen goed!
          </div>
        )}
      </TekstPaneel>

      <div style={stijlen.toetsPaneel}>
        <h3 style={{ ...stijlen.paneelLabel, marginBottom: 8 }}>Toets - Deel 2</h3>
        <h2 style={stijlen.paneelTitel}>Open vragen</h2>
        {vragen.map((v, i) => (
          <div key={v.id} style={stijlen.vraagBlok}>
            <h4 style={stijlen.vraagNummer}>Vraag {i + 1}</h4>
            <p style={stijlen.vraagTekst}>{v.vraag}</p>
            <textarea
              style={{
                width: '100%',
                padding: 12,
                borderRadius: 8,
                border: '2px solid var(--lijn)',
                fontSize: 15,
                lineHeight: 1.6,
                resize: 'vertical',
                minHeight: 100,
              }}
              rows={4}
              value={antwoorden[v.id] || ''}
              onChange={e => onTyp(v.id, e.target.value)}
              placeholder="Typ hier je antwoord..."
            />
          </div>
        ))}
        {/* Zolang het versturen loopt, kan het niet nog een keer. */}
        <button style={{ ...stijlen.groteKnop, opacity: compleet && !bezig ? 1 : 0.5 }} onClick={onVerstuur}
          disabled={!compleet || bezig}>
          <Send size={18} /> {bezig ? 'Versturen...' : 'Verstuur antwoorden'}
        </button>
      </div>
    </div>
  );
}
